import s from './SmallBigImages.module.scss'
import LazyImage from '@/components/Common/LazyImage'
import LazyVideo from '@/components/Common/LazyVideo'

type Props = { data: any; priority?: boolean }

export default function SmallBigImages({ data, priority = false }: Props) {
  return (
    <div className={`${s.smallBigImages} ${s[data.side]}`}>
      <div className={`${s.imageWrapper} ${s.small}`}>
        {data.smallVideoUrl ? (
          <LazyVideo
            src={data.smallVideoUrl}
            thumbnail={data.smallImage}
            autoplay={true}
            muted={true}
            allowAudio={data.smallAllowAudio}
            fullHeight
          />
        ) : (
          <LazyImage
            src={data.smallImage?.imageUrl}
            alt={data.smallImage?.filename || 'Small Image'}
            width={data.smallImage?.metadata.dimensions.width || 800}
            height={data.smallImage?.metadata.dimensions.height || 600}
            priority={priority}
          />
        )}
      </div>
      <div className={`${s.imageWrapper} ${s.big}`}>
        {data.bigVideoUrl ? (
          <LazyVideo
            src={data.bigVideoUrl}
            thumbnail={data.bigImage}
            autoplay={true}
            muted={true}
            allowAudio={data.bigAllowAudio}
            fullHeight
          />
        ) : (
          <LazyImage
            src={data.bigImage?.imageUrl}
            alt={data.bigImage?.filename || 'Big Image'}
            width={data.bigImage?.metadata.dimensions.width || 800}
            height={data.bigImage?.metadata.dimensions.height || 600}
          />
        )}
      </div>
    </div>
  )
}
